import {handleActions} from 'redux-actions'
import * as type from './type'

export const initialState = {
    processList: null,
    fetching: false,
    error: null,
    commentText: null,
    isInternal: false,
}

export default handleActions({

    [type.CHANGE_IS_COMMENT_INTERNAL]: (state, action) => {
        const { value } = action.payload
        return {
            ...state,
            isInternal: value,
        }
    },
    [type.CHANGE_PROCESS_COMMENT]: (state, action) => {
        const { value } = action.payload
        return {
            ...state,
            commentText: value,
        }
    },
    [type.COMMENT_PROCESS_INSTANCE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.COMMENT_PROCESS_INSTANCE_SUCCESS]: (state, action) => {
        const { comment } = action.payload
        const processList = state.processList;
        processList[processList.length - 1].processCommentList.push(comment);
        return {
            ...state,
            fetching: false,
            error: null,
            commentText: '',
            processList: processList,
        }
    },
    [type.COMMENT_PROCESS_INSTANCE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.FIND_PROCESS_COMMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.FIND_PROCESS_COMMENT_SUCCESS]: (state, action) => {
        const {processList} = action.payload
        return {
            ...state,
            processList,
            fetching: false,
        }
    },
    [type.FIND_PROCESS_COMMENT_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/tab-comments/reducer.js